import { Application, RequestHandler } from 'express';
import { getApiLimiter, getAuthLimiter, getSensitiveLimiter, initializeRateLimiters } from '../limits/limiters';
import { logger } from '../logger/logger';
import { RateLimitRule } from '../types/types';
import { API_ENDPOINT_HEADER } from '../configs/apiEndpoints';

export async function configureRateLimits(app: Application): Promise<void> {
  try {
    await  initializeRateLimiters()
    const apiLimiter = getApiLimiter();
    const authLimiter = getAuthLimiter();
    const sensitiveLimiter = getSensitiveLimiter();

    const rateLimitRules: RateLimitRule[] = [
      { paths: ['/api', '/api/v1'], limiter: apiLimiter },
      {
        paths: ['/api/auth', '/api/v1/auth'],
        limiter: authLimiter,
        condition: (req) => ['/login', '/register', '/authenticate'].some(p => req.path.includes(p))
      },
      {
        paths: ['/api'],
        limiter: sensitiveLimiter,
        condition: (req) => req.path.includes('/2fa') ||
          ['auth:2fa-setup', 'auth:2fa-enable', 'auth:2fa-disable', 'auth:2fa-verify']
            .includes((req.headers[API_ENDPOINT_HEADER] || req.headers[API_ENDPOINT_HEADER.toLowerCase()]) as string)
      }
    ];

    rateLimitRules.forEach(rule => {
      if (rule.condition) {
        const middleware: RequestHandler = (req, res, next) =>
          rule.condition!(req) ? rule.limiter(req, res, next) : next();
        app.use(rule.paths, middleware);
      } else {
        app.use(rule.paths, rule.limiter);
      }
    });

    logger.info('Rate limiting configured successfully');
  } catch (error) {
    logger.error('Failed to configure rate limiting:', error);
    throw error;
  }
}
